import CIMSTable from 'components/CIMSTable'
import { useColumns } from './hooks/useColumns'
import { useReportFilenamesContext } from './ReportFilenamesContext'
import { useEditFilenameModal } from '../EditFilenameModal/hooks/useEditFilenameModal'
import { ReportFilename } from './ReportFilenamesContext/types'
import EditFilenameModal from '../EditFilenameModal'
import { Permission } from '@cims-online/shared'
import ModalExample from './components/ModalExample'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { useEditReportFilenameMutation } from 'schema'
import { simpleEditNotification } from 'hooks/notificationHandler'

const ReportFilenames: React.FC = () => {
  const {
    reportFilenames,
    loading,
    refetch: onReload,
  } = useReportFilenamesContext()
  const columns = useColumns()
  const context = useEditFilenameModal<ReportFilename>()
  const [edit] = useEditReportFilenameMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      editReportFilename: {
        reportFilename: { report },
      },
    }) => simpleEditNotification(`Filename for ${report}`),
  })
  return (
    <CIMSTable
      columns={columns}
      records={reportFilenames}
      rowKey="id"
      loading={loading}
      actions={{
        header: { onReload },
        row: {
          edit: {
            permission: Permission.EditFilename,
            modal: {
              type: 'custom',
              toggle: (record) => context.toggle(record),
            },
          },
        },
      }}
    >
      <EditFilenameModal
        context={context}
        type="report"
        name={(state) => state?.name}
        edit={({ id: reportId }, projectId, templateItems) =>
          edit({ variables: { input: { projectId, reportId, templateItems } } })
        }
        postEdit={onReload}
      >
        <ModalExample {...context} />
      </EditFilenameModal>
    </CIMSTable>
  )
}

export default ReportFilenames
